import axios from 'axios'

const getReferralCode = ({ token }: { token: string }) => {
    const url = 'https://hydra.unicity.net/v5a/customers/me/referralcodes'
    return axios.get(url, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-application': 'asia.spotlight'
        }
    })
}

export const paymentResponseApis = {
    getReferralCode
}
